import { builtinNativeClasses, nativeClasses } from './builtinNativeClasses';
export function getNativeInitializer(classInfo) {
    var _a;
    var methodInfo = classInfo.instanceInfo.getInitializer();
    var className = classInfo.instanceInfo.getClassName();
    var asClass = builtinNativeClasses[className] || nativeClasses[className];
    if (methodInfo.isNative() || ((_a = asClass) === null || _a === void 0 ? void 0 : _a.forceNativeConstructor)) {
        // Use TS constructor as the initializer function.
        return asClass;
    }
    //// TODO: Assert eagerly.
    //return function () {
    //  release || assert (!methodInfo.isNative(), "Must supply a constructor for " + classInfo +
    // "."); }
    return null;
}
